// extracted by mini-css-extract-plugin
export default {"ProjectTaskList":"projectTaskList_ProjectTaskList__099tz","empty_wrap":"projectTaskList_empty_wrap__k0l+Y"};